// AdAccountList.tsx - Material React Table 버전
import { useEffect, useState } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Box, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { LoadRecruteDetail, RecruitScheduleData } from './useLoadRecruitSchedule';
import { ModalAdSheduleAddStore, useModalStore } from 'src/stores/ModalStore';
import ModalTitleScheduleDetail from './ModalTitleScheduleDetail';
import ModalContentScheduleDetail from './ModalContentScheduleDetail';
import { useAdRecruitStore } from 'src/stores/AdRecruitStore';

const TableHeaderSx = {
  backgroundColor: '#30515B',
  color: 'white',
  fontSize: '14px',
  textAlign: 'center',
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
}

const TableRowSx = {
  height: '49px',
  '& > td:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '& > td:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '& > td': {
    background: '#FFF',
    boxShadow: '1px 2px 2px rgba(0, 0, 0, 0.1)',
    padding: '4px',
  },
}

const TableCellSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '16px',
}

export const getStatusFromRow = (row: any): string => {
  const { is_active, admin_approval } = row;
  if (!is_active && !admin_approval) return '대기';
  if (!is_active && admin_approval) return '차단';
  if (is_active && admin_approval) return '승인';
  return ''; // 기타 상태는 필터링 제외
};

interface Props{
  propsData : RecruitScheduleData[]
}

const Recruit_ScheduleTable = ({propsData}:Props) => {
  const modalSetField = useModalStore((state)=>state.setField)
  const modalAdSheduleSetField = ModalAdSheduleAddStore((state)=>state.setField)
  const page = useAdRecruitStore((state)=>state.page)
  const type = useAdRecruitStore((state)=>state.type)
  const status = useAdRecruitStore((state)=>state.status)
  const totalPage = useAdRecruitStore((state)=>state.totalPage)
  const sort_by = useAdRecruitStore((state)=>state.sort_by)
  const sort_order = useAdRecruitStore((state)=>state.sort_order)
  const setField = useAdRecruitStore((state)=>state.setField)


  const [pagination, setPagination] = useState({
    pageIndex: page-1,
    pageSize: 8,
  });
  useEffect(()=>{
    setPagination((prev) => ({ ...prev, pageIndex: 0 }))
  },[type ,status])
  const totalPages = totalPage;
  const handlePageChange = (page: number) => {
    setPagination((prev) => ({ ...prev, pageIndex: page }));
    setField('page',page+1); // 부모에게 알림
  };
  
  return (
    <div style={{height:'100%'}}>
    <MaterialReactTable
      data={propsData}
      muiTableContainerProps={{
        sx: { 
          height: 'calc(100vh - 450px)',
          overflowY: 'auto',
          overflowX: 'auto',
          width: 'calc(100vw - 425px)'
        }
      }}
      columns={[
        {
          header: '순서',
          Cell: ({ row }) => pagination.pageIndex * pagination.pageSize + row.index + 1,
          size: 50, // 필요에 따라 너비 지정
          enableSorting: false, // ✅ 정렬 비활성화
        },
        { accessorKey: 'recruitment_type',header: '모집유형', enableSorting: false },
        { accessorKey: 'title', header: '공고명', enableSorting: false },
        { accessorKey: 'application_sdate', header: '접수 시작일' },
        { accessorKey: 'application_edate', header: '접수 마감일' },
        { accessorKey: 'created_at', header: '모집 공고 등록일' },
        { accessorKey: 'calculated_status', header: '상태', enableSorting: false },
      ]}
      // 툴바, sort 버튼 등
      enableTopToolbar={false}
      enableBottomToolbar={false}
      enableColumnActions={false}
      enableSorting={true}
      muiTablePaperProps={{
        elevation: 0, // ✅ 그림자 제거
      }}
      // 로우 헤더 스타일
      muiTableHeadCellProps={{
        sx: TableHeaderSx,
      }}
      // 로우 스타일
      muiTableBodyRowProps={({ row }) => ({
        sx: TableRowSx,
        onClick:  async () => {
          const response = await LoadRecruteDetail(row.original.announce_id)
          modalAdSheduleSetField('returnData',response)
          modalAdSheduleSetField('idValue',row.original.announce_id)
          modalSetField('type','CENTER')
          modalSetField('title',<ModalTitleScheduleDetail/>)
          modalSetField('content',<ModalContentScheduleDetail/>)
          modalSetField('width','1024px')
          modalSetField('padding','20px')
          modalSetField('open',true)
        },
      })}
      // 셀 스타일
      muiTableBodyCellProps={{
        sx: TableCellSx,
      }}
      // 테이블 스타일
      muiTableProps={{
        sx: {
          borderCollapse: 'separate',
          borderSpacing: '0 5px', // ✅ row 간격 5px
          '& .MuiTableSortLabel-icon': {
            color: '#aaa',
            fontSize: '1.5rem',
          },
          '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
            color: 'rgb(255, 255, 255) !important',
          },
      }}}
      // 페이지 네이션 옵션
      state={{ pagination,
        sorting: sort_by
        ? [
            {
              id: sort_by,
              desc: sort_order === 'desc',
            },
          ]
        : [],
       }}
      manualPagination 
      pageCount={totalPages} // 수동 계산 필요 시
      // 솔팅 옵션
      manualSorting
      enableSortingRemoval={false}
      onSortingChange={(updater)=>{
        const sorting = typeof updater === 'function' ? updater([]) : updater;

        if (sorting.length > 0) {
          const sort = sorting[0];
          setField('sort_by',sort.id); // 정렬할 컬럼의 accessorKey 또는 accessorFn id
          setField('sort_order',sort.desc ? 'desc' : 'asc');
        } 
      }}
      />
      {propsData.length !== 0 &&
        <Box display="flex" justifyContent="center" mt={2} gap={1}>
        {/* 이전 버튼 */}
        <IconButton
          onClick={() => handlePageChange(Math.max(pagination.pageIndex - 1, 0))}
          disabled={pagination.pageIndex === 0}
          aria-label="이전 페이지"
        >
          <ChevronLeft />
        </IconButton>

        {/* 숫자 버튼 */}
        {Array.from({ length: totalPage }).map((_, index) => (
          <IconButton
            key={index}
            onClick={() => handlePageChange(index)}
            sx={{
              backgroundColor:
                pagination.pageIndex === index ? '#50818b' : 'transparent',
              color: pagination.pageIndex === index ? '#fff' : '#666',
              '&:hover': {
                backgroundColor:
                  pagination.pageIndex === index ? '#4a747d' : '#f0f0f0',
              },
              width: 32,
              height: 32,
              fontSize: 14,
            }}
          >
            {index + 1}
          </IconButton>
        ))}

        {/* 다음 버튼 */}
        <IconButton
          onClick={() =>
            handlePageChange(Math.min(pagination.pageIndex + 1, totalPage - 1))
          }
          disabled={pagination.pageIndex === totalPage - 1}
          aria-label="다음 페이지"
        >
          <ChevronRight />
        </IconButton>
      </Box>
      }
    </div>
  );
};

export default Recruit_ScheduleTable;
